<template>
  <div class="videoMaterial">
    <div>
      <el-row :gutter="20">
        <el-col :sm="12" :md="6" :lg="4">
          <el-button type="primary" @click="videoVisible = true" v-auth="'/materialCenter/syncTecentVideo'">上传视频</el-button>
        </el-col>
        <el-col :sm="12" :md="18" :lg="20" style="text-align: right" v-auth="'/materialCenter/pageListVideo'">
          <el-input style="width: 200px; margin-right: 10px" placeholder="请输入视频名称" auto-complete="off" v-model="searchForm.name" clearable @keyup.enter.native="; (page.pageNumber = 1), pageList()"></el-input>
          <el-button type="primary" @click="; (page.pageNumber = 1), pageList()">查询</el-button>
        </el-col>
      </el-row>
    </div>
    <div style="display: flex; margin-top: 10px">
      <div class="photoMaterial-left">
        <div class="photoMaterial-left-title">
          视频分组
          <span v-auth="'/materialCenter/addFodderGroupInfoVideo'" @click="
            addForm.parentId = 0
            groupsVisible = true
          " class="iconPlus operItem el-icon-plus"></span>
        </div>
        <div class="photoMaterial-left-input">
          <el-input placeholder="请输入分组名称" v-model="searchFodderGroupForm.name" auto-complete="off" @keyup.enter.native="getFodderGroupInfoTree">
            <i class="el-icon-search el-input__icon" slot="suffix" @click="getFodderGroupInfoTree"></i>
          </el-input>
        </div>
        <el-tree :data="fodderGroupInfoList" :props="defaultProps" :expand-on-click-node="false" class="research-tree" ref="tree" node-key="id">
          <span class="span-ellipsis" slot-scope="{ node, data }">
            <span @click="treeClick(data)">
              <i style="color: #409eff; font-size: 14px" class="icon iconfont2 icon-wenjian"></i>
              <span style="margin-left: 10px">{{ data.name }}</span>
              <div class="material_operation" v-if="data.name !== '全部视频' && data.name !== '默认分组'">
                <span v-auth="'/materialCenter/addFodderGroupInfoTwoVideo'" style="font-size: 16px" @click="
                  addForm.parentId = data.id
                  groupsVisible = true
                " class="el-icon-circle-plus-outline"></span>
                <el-dropdown>
                  <div class="el-dropdown-link" v-auth="'/materialCenter/delOrNameVideo'">
                    <span style="font-size: 16px; color: #409eff" class="el-icon-more"></span>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item style="font-size: 12px" @click.native="rename(data)">重命名</el-dropdown-item>
                    <el-dropdown-item style="font-size: 12px" @click.native="deleteFodderGroupInfo(data.id)">删除分组</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </span>
          </span>
        </el-tree>
      </div>
      <div class="photoMaterial-right">
        <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="page.rows" tooltip-effect="dark" style="margin-top: 0px" border @selection-change="selectionVideoChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="name" label="视频" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="size" label="大小" width="180">
            <template slot-scope="scope">{{ (scope.row.size / 1024 / 1024).toFixed(4) }}MB</template>
          </el-table-column>
          <el-table-column prop="createTime" label="上传时间" width="180"></el-table-column>
          <!-- <el-table-column prop="name" label="状态" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.state==1">正常</span>
              <span v-else>异常</span>
            </template>
          </el-table-column>-->
          <el-table-column prop label="操作" width="160" align="center">
            <template slot-scope="scope">
              <div class="operationGroup">
                <span class="operation-style" @click="edit(scope.row)" v-auth="'/materialCenter/updateAttachmentVideo'">编辑</span>
                <span class="operation-style" @click="down(scope.row)" v-auth="'/materialCenter/downVideo'">下载</span>
                <span class="operation-style" @click="deleteVideo(scope.row)" v-auth="'/materialCenter/deleteAttachmentVideo'">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex; justify-content: space-between">
          <div style="display: flex; margin-top: 20px; padding: 2px">
            <div style="line-height: 28px; color: #a2aabc; margin-left: 20px">
              已选{{ ids.length }}条
            </div>
            <div class="photoMaterial-button" @click="delectVideoList()" v-auth="'/materialCenter/deleteAttachmentVideo'">
              批量删除
            </div>
            <div class="photoMaterial-button" @click="selectTransferFodder(1)" v-auth="'/materialCenter/selectTransferFodderOneVideo'">
              移动到
            </div>
            <div class="photoMaterial-button" @click="selectTransferFodder(2)" v-auth="'/materialCenter/selectTransferFodderTwoVideo'">
              全部移动到
            </div>
          </div>
          <el-pagination background layout="total, prev, pager, next" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
        </div>
      </div>
      <el-dialog title="上传视频" :visible.sync="videoVisible" width="800px" left :close-on-click-modal="false">
        <el-form ref="addTecentVideoForm" :model="addTecentVideoForm" :label-width="formLabelWidth" :rules="addTecentVideoFormRules">
          <el-form-item label="上传到" prop="id">
            <el-cascader clearable v-model="addTecentVideoForm.id" :show-all-levels="false" placeholder="请选择" :options="fodderGroupInfoList" :props="props"></el-cascader>
          </el-form-item>
          <el-form-item label="本地文件" prop="avatar">
            <el-upload class="upload-demo" ref="upload" action :http-request="handleAvatarSuccess" multiple>
              <el-button type="primary" plain slot="trigger">选择文件</el-button>
              <span style="margin-left: 10px">1.支持mp4、avi、wmv格式，大小不超过2GB；2.一次最多上传100个文件</span>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="videoMaterialList" tooltip-effect="dark" style="margin-top: 0px; width: 100%" border @selection-change="selectionChange">
          <el-table-column type="selection" :selectable="checkSelection" width="50"></el-table-column>
          <el-table-column prop="name" label="视频"></el-table-column>
          <el-table-column prop="size" label="大小" width="80">
            <template slot-scope="scope">{{ (scope.row.size / 1024 / 1024).toFixed(2) }}MB</template>
          </el-table-column>
          <el-table-column prop="percent" label="进度" width="80"></el-table-column>
          <el-table-column prop label="操作" width="80" align="center">
            <template slot-scope="scope">
              <span class="operation-style" @click="deleteVideoMaterial(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex; justify-content: space-between">
          <div style="display: flex; margin-top: 5px; padding: 2px">
            <div style="line-height: 28px; color: #a2aabc">
              已选{{ addTecentVideoForm.fileIds.length }}条
            </div>
            <div class="photoMaterial-button" @click="deleteVideoMaterialList()">
              批量删除
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="videoVisible = false">取 消</el-button>
          <el-button type="primary" @click="syncTecentVideo" :loading="syncTecentVideoBlock">确认上传</el-button>
        </div>
      </el-dialog>

      <el-dialog title="编辑视频" :visible.sync="editPhotoVisible" width="400px" left :close-on-click-modal="false">
        <el-form ref="editPhotoForm" :model="editPhotoForm" :label-width="formLabelWidth" :rules="editPhotoFormRules">
          <el-form-item label="名称" prop="name">
            <el-input style="width: 100%" v-model="editPhotoForm.name" placeholder="请输入图片名称"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="editPhotoVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateAttachment()" :loading="updateAttachmentBlock">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加分组" :visible.sync="groupsVisible" width="400px" left :close-on-click-modal="false">
        <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
          <el-form-item label="分组名称" prop="name">
            <el-input style="width: 100%" v-model="addForm.name" maxlength="10" placeholder="请输入分组名称"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="groupsVisible = false">取 消</el-button>
          <el-button type="primary" @click="addFodderGroupInfo">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="素材移动到" :visible.sync="moveVisible" width="400px" left :close-on-click-modal="false">
        <el-tree :data="fodderGroupInfoList" :props="defaultProps" :highlight-current="true" :expand-on-click-node="false" class="research-tree" ref="tree2" node-key="id" current-node-key>
          <span class="span-ellipsis" slot-scope="{ node, data }">
            <span @click="transferTreeClick(data)">
              <i style="color: #409eff; font-size: 14px" class="icon iconfont2 icon-wenjian"></i>
              <span style="margin-left: 10px">{{ data.name }}</span>
            </span>
          </span>
        </el-tree>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="moveVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="编辑分组名称" :visible.sync="editGroupsVisible" width="400px" left :close-on-click-modal="false">
        <el-form ref="editGroupsForm" :model="editGroupsForm" :label-width="formLabelWidth" :rules="editGroupsFormRules">
          <el-form-item label="名称" prop="name">
            <el-input style="width: 100%" v-model="editGroupsForm.name" placeholder="请输入分组名称"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="editGroupsVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateFodderGroupInfo()" :loading="updateAttachmentBlock">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { uploadTC } from "../../upload/tecent";
import axios from "axios";
import { uploadOSS } from "../../upload/upload";
import TcVod from "vod-js-sdk-v6";
import Common from "../../upload/Common";
import md5 from "md5";
import $ from "jquery";
export default {
  data () {
    return {
      syncTecentVideoBlock: false,
      updateAttachmentBlock: false,
      updateFodderGroupInfoBlock: false,
      editPhotoVisible: false,
      editGroupsVisible: false,
      fileActive: 0,
      selectSubmit: 1,
      dialogFileActive: 0,
      groupsVisible: false,
      videoVisible: false,
      moveVisible: false,
      formLabelWidth: "80px",
      addForm: {
        name: null,
        parentId: null,
        type: 2,
      },
      addTecentVideoForm: {
        id: null,
        fileIds: [],
      },
      uids: [],
      editGroupsForm: {},
      addTecentVideoFormRules: {
        id: {
          required: true,
          message: "请选择分组",
          trigger: "change",
        },
      },
      editPhotoForm: {},
      videoMaterialList: [],
      fodderGroupInfoList: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      props: {
        value: "id",
        children: "children",
        label: "name",
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      searchForm: {
        type: 2,
      },
      searchFodderGroupForm: {
        type: 2,
        name: null,
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "分组名称长度在1到10个字",
          },
        ],
      },

      editPhotoFormRules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "分组名称长度在1到10个字",
          },
        ],
      },

      editGroupsFormRules: {
        name: [
          {
            required: true,
            message: "请输入分组名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "分组名称长度在1到10个字",
          },
        ],
      },
      addPhotoFormRules: {},
      loading: false,
      fileIds: [],
      ids: [],
      fodderGroupInfoName: null,
      id: null,
    };
  },
  computed: {
    videoPercent: function () {
      return this.$store.state.percent;
    },
  },
  methods: {
    // 上传视频检查是否可选
    checkSelection (row) {
      return row.fileId;
    },

    /*---------------------------pageList列表操作-------------------------*/
    treeClick (data) {
      this.id = data.id;
      this.fodderGroupInfoName = data.name;
      if (data.name == "全部视频") {
        this.searchForm.fodderGroupInfoId = "";
      } else {
        this.searchForm.fodderGroupInfoId = data.id;
      }
      this.pageList();
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },

    selectionVideoChange (val) {
      this.ids = [];
      let obj = {};
      val.forEach((e) => {
        this.ids.push({ id: e.id });
      });
    },
    pageList () {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.api.attachment
        .pageList(this.searchForm)
        .then((result) => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.$emit("attachmentSizeChange", true);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteVideo (row) {
      this.$confirm("将会删除该视频，是否确认删除？", "系统消息", {
        type: "warning",
      }).then(() => {
        let obj = {
          id: row.id,
        };
        this.api.attachment.deleteAttachment([obj]).then((res) => {
          if (res.success && res.message == 'showVerifyDelVideo') {//显示删除视频影响范围
            console.info(res);
            debugger
            const msgStrList = [];
            const h = this.$createElement;
            msgStrList.push(h('p','要删除的视频已存在如下关联关系:'));
            if (res.data.videoCourseNameList != null) {
              msgStrList.push(h('p', '关联录播信息：'));
              $.each(res.data.videoCourseNameList, function (index, item) {
                msgStrList.push(h('p', (index + 1) + ":" + item));
              });
            }
            if(res.data.goodsInfoNameList != null){
              msgStrList.push(h('p',"关联商品信息:"));
              $.each(res.data.goodsInfoNameList,function (index, item) {
                msgStrList.push(h('p',(index+1)+"："+item));
              });
            }
            if(res.data.xiaoETNameList != null){
              msgStrList.push(h('p',"关联直播信息:"));
              $.each(res.data.xiaoETNameList, function (index, item) {
                  msgStrList.push(h('p', (index + 1) + "：" + item));
              });
            }
            msgStrList.push(h('p',"是否确认联动删除上诉关联关系？"));
            this.$confirm( h('div',msgStrList),"删除重要消息",
              {
                type: "warning",
              }).then(() => {
              this.api.attachment.deleteAttachmentAndRelationByVideo([obj]).then((res) => {
                if (res.success) {
                  this.$message.success(res.message);
                  this.pageList();
                } else {
                  this.$message.error(res.message);
                }
              });
            });
          }else if (res.success) {
            this.$message.success(res.message);
            this.pageList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    delectVideoList () {
      if (this.ids.length == 0) {
        this.$message.warning("请选择需要删除的视频！");
      } else {
        this.$confirm("将会删除选中视频，是否确认删除？", "系统消息", {
          type: "warning",
        }).then(() => {
          this.api.attachment.deleteAttachment(this.ids).then((res) => {
            if (res.success && res.message == 'showVerifyDelVideo') {//显示删除视频影响范围
              console.info(res);
              debugger
              const msgStrList = [];
              const h = this.$createElement;
              msgStrList.push(h('p','要删除的视频已存在如下关联关系:'));
              if (res.data.videoCourseNameList != null) {
                msgStrList.push(h('p', '关联录播信息：'));
                $.each(res.data.videoCourseNameList, function (index, item) {
                  msgStrList.push(h('p', (index + 1) + ":" + item));
                });
              }
              if(res.data.goodsInfoNameList != null){
                msgStrList.push(h('p',"关联商品信息:"));
                $.each(res.data.goodsInfoNameList,function (index, item) {
                  msgStrList.push(h('p',(index+1)+"："+item));
                });
              }
              if(res.data.xiaoETNameList != null){
                msgStrList.push(h('p',"关联直播信息:"));
                $.each(res.data.xiaoETNameList, function (index, item) {
                  msgStrList.push(h('p', (index + 1) + "：" + item));
                });
              }
              msgStrList.push(h('p',"是否确认联动删除上诉关联关系？"));
              this.$confirm( h('div',msgStrList),"删除重要消息",
                {
                  type: "warning",
                }).then(() => {
                this.api.attachment.deleteAttachmentAndRelationByVideo(this.ids).then((res) => {
                  if (res.success) {
                    this.$message.success(res.message);
                    this.pageList();
                  } else {
                    this.$message.error(res.message);
                  }
                });
              });
            }else if (res.success) {
              this.$message.success(res.message);
              this.pageList();
            } else {
              this.$message.error(res.message);
            }
          });
        });
      }
    },

    selectTransferFodder (num) {
      if (num == 1) {
        if (this.ids.length == 0) {
          this.$message.warning("请选中需要移动的视频！");
        } else {
          this.moveVisible = true;
        }
      } else {
        if (
          this.fodderGroupInfoName == "全部视频" ||
          this.fodderGroupInfoName == "默认分组"
        ) {
          this.$message.warning("默认分组不可以转移视频！");
        } else {
          this.moveVisible = true;
        }
      }
      this.selectSubmit = num;
    },

    transferTreeClick (data) {
      this.fodderGroupInfoId = data.id;
    },

    submit () {
      if (this.selectSubmit == 1) {
        this.transferFodder();
      } else {
        this.transferFodderByFodderGroupInfoId();
      }
    },

    transferFodder () {
      let obj = {
        id: this.fodderGroupInfoId,
        attachmentList: this.ids,
      };
      this.api.fodderGroupInfo.transferFodder(obj).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.page.pageNumber = 1;
          this.pageList();
          this.moveVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    transferFodderByFodderGroupInfoId () {
      let obj = {
        fodderGroupInfoId: this.fodderGroupInfoId,
        id: this.id,
      };
      this.api.fodderGroupInfo
        .transferFodderByFodderGroupInfoId(obj)
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.page.pageNumber = 1;
            this.pageList();
            this.moveVisible = false;
          } else {
            this.$message.error(res.message);
          }
        });
    },

    /*---------------------------上传视频-------------------------*/

    handleAvatarSuccess (file) {
      if (file.file.type.indexOf("video") > -1) {
        let data = {
          name: file.file.name,
          size: file.file.size,
          percent: 0,
          uid: file.file.uid,
        };
        this.videoMaterialList.push(data);
        uploadTC(file).then((res) => { });
      } else {
        this.$message.error("请上传视频文件！")
      }
    },

    selectionChange (val) {
      this.addTecentVideoForm.fileIds = [];
      let obj = {};
      val.forEach((e) => {
        obj = {
          size: e.size,
          fileId: e.fileId,
        };
        this.addTecentVideoForm.fileIds.push(obj);
        this.uids.push(e.uid)
      });
    },

    edit (row) {
      this.editPhotoForm = row;
      this.editPhotoVisible = true;
    },

    updateAttachment () {
      if (this.updateAttachmentBlock) {
        return;
      }
      this.updateAttachmentBlock = true;
      this.api.fodderGroupInfo
        .updateAttachment(this.editPhotoForm)
        .then((res) => {
          if (res.success) {
            this.editPhotoVisible = false;
            this.updateAttachmentBlock = false;
            this.pageList();
          } else {
            this.updateAttachmentBlock = false;
            this.$message.success(res.message);
          }
        });
    },

    down (row) {
      if (row.type == 'mp4 ') {
        var url = row.url;
        if(url.indexOf("https") == -1){
          var url1 = url.replace('http','https');
          window.open(url1);
        }
        else{
          window.open(url);
        }
      } else {
        var x = new XMLHttpRequest();
        var url = row.url;
        if(url.indexOf("https") == -1){
          var url1 = url.replace('http','https');
          // window.open(url1);
          // console.log(url1);
          x.open("GET", url1, true);
          x.responseType = "blob";
          x.onload = function (e) {
            if (x.readyState === 4 && x.status === 200) {
              let blob = this.response;
              // 转换一个blob链接
              let u = window.URL.createObjectURL(new Blob([blob]))
              let a = document.createElement('a');
              a.download = row.name + '.' + row.type;
              a.href = u;
              a.style.display = 'none'
              document.body.appendChild(a)
              a.click();
              a.remove();
            }
          };
          x.send();
        }
        else{
          x.open("GET", url, true);
          x.responseType = "blob";
          x.onload = function (e) {
            if (x.readyState === 4 && x.status === 200) {
              let blob = this.response;
              // 转换一个blob链接
              let u = window.URL.createObjectURL(new Blob([blob]))
              let a = document.createElement('a');
              a.download = row.name + '.' + row.type;
              a.href = u;
              a.style.display = 'none'
              document.body.appendChild(a)
              a.click();
              a.remove();
            }
          };
          x.send();
        }
      }

    },

    deleteVideoMaterial (row) {
      this.$confirm("将会删除该视频，是否确认删除？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.videoMaterialList.forEach((item, index) => {
          if (row.uid == item.uid) {
            this.videoMaterialList.splice(index, 1);
          }
        });
      });
    },

    deleteVideoMaterialList () {
      this.$confirm("将会删除选中视频，是否确认删除？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.uids.forEach((e) => {
          this.videoMaterialList.forEach((item, index) => {
            if (e === item.uid) {
              this.videoMaterialList.splice(index, 1)
            }
          });
        });
      });
    },

    syncTecentVideo () {
      this.$refs.addTecentVideoForm.validate().then((valid) => {
        if (valid) {
          if (this.syncTecentVideoBlock) {
            return;
          }
          if (this.addTecentVideoForm.fileIds.length == 0) {
            return this.$message.error("请选择需要上传的文件");
          }
          this.syncTecentVideoBlock = true;
          let len = this.addTecentVideoForm.id.length;
          if (typeof (this.addTecentVideoForm.id) === 'object') {
            this.addTecentVideoForm.id = this.addTecentVideoForm.id[len - 1]
          }
          this.api.syncTecentVideo(this.addTecentVideoForm).then((res) => {
            if (res.success) {
              this.addTecentVideoForm.fileIds.forEach((e) => {
                this.videoMaterialList.forEach((item, index) => {
                  if (e.fileId === item.fileId) {
                    this.videoMaterialList.splice(index, 1)
                  }
                })
              })
              if (this.videoMaterialList.length === 0) {
                this.videoVisible = false
                this.pageList()
              }
              this.syncTecentVideoBlock = false;
              this.$message.success(res.message);
            } else {
              this.syncTecentVideoBlock = false;
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    /*---------------------------分组管理-------------------------*/
    getFodderGroupInfoTree () {
      if (this.searchFodderGroupForm.name == "") {
        this.searchFodderGroupForm.name = null;
      }
      this.api.fodderGroupInfo
        .getFodderGroupInfoTree(this.searchFodderGroupForm)
        .then((res) => {
          if (res.success) {
            this.fodderGroupInfoList = res.data;
            this.$nextTick(function () {
              this.$refs.tree.setCurrentKey(res.data[0].id);
              this.id = res.data[0].id;
              this.fodderGroupInfoName = res.data[0].name;
            });
            this.pageList();
          } else {
            this.$message.error(res.message);
          }
        });
    },
    addFodderGroupInfo () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.api.fodderGroupInfo
            .addFodderGroupInfo(this.addForm)
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message);
                this.getFodderGroupInfoTree();
                this.groupsVisible = false;
              } else {
                this.$message.error(res.message);
              }
            });
        }
      });
    },

    rename (row) {
      this.editGroupsForm = row;
      this.editGroupsVisible = true;
    },
    updateFodderGroupInfo () {
      if (this.updateFodderGroupInfoBlock) {
        return;
      }
      this.updateFodderGroupInfoBlock = true;
      this.$refs.editGroupsForm.validate().then((valid) => {
        if (valid) {
          this.api.fodderGroupInfo
            .updateFodderGroupInfo(this.editGroupsForm)
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message);
                this.editGroupsVisible = false;
                this.updateFodderGroupInfoBlock = false;
                this.getFodderGroupInfoTree();
              } else {
                this.updateFodderGroupInfoBlock = false;
                this.$message.error(res.message);
              }
            });
        }
      });
    },

    deleteFodderGroupInfo (id) {
      this.$confirm("将会删除该分组，是否确认删除？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.api.fodderGroupInfo
          .deleteFodderGroupInfo({ id: id })
          .then((res) => {
            if (res.success) {
              this.$message.success(res.message);
              this.getFodderGroupInfoTree();
            } else {
              this.$message.error(res.message);
            }
          });
      });
    },
  },
  mounted () {
    this.getFodderGroupInfoTree();
  },
  watch: {
    groupsVisible: function (newVal) {
      if (!newVal) {
        this.addForm.name = "";
      } else {
      }
    },
    videoVisible: function (newVal) {
      if (!newVal) {
        this.addTecentVideoForm.fileIds = [];
        this.videoMaterialList = [];
        this.addTecentVideoForm.id = null;
        this.pageList()
      }
    },
    "$store.state.uploadData.percent": function (newVal) {
      if (!newVal) {
      } else {
        let len = this.videoMaterialList.length;
        for (let i = 0; i < len; i++) {
          if (
            this.videoMaterialList[i].uid == this.$store.state.uploadData.index
          ) {
            this.$set(
              this.videoMaterialList[i],
              "percent",
              this.$store.state.uploadData.percent * 100 + "%"
            );
          }
        }
      }
    },
    "$store.state.uploadData.index": function (newVal) {
      if (!newVal) {
      } else {
        let len = this.videoMaterialList.length;
        for (let i = 0; i < len; i++) {
          if (
            this.videoMaterialList[i].uid == this.$store.state.uploadData.index
          ) {
            this.$set(
              this.videoMaterialList[i],
              "percent",
              this.$store.state.uploadData.percent * 100 + "%"
            );
          }
        }
      }
    },
    "$store.state.fileIdData.fileId": function (newVal) {
      if (!newVal) {
      } else {
        let len = this.videoMaterialList.length;
        for (let i = 0; i < len; i++) {
          if (
            this.videoMaterialList[i].uid == this.$store.state.fileIdData.uid
          ) {
            this.$set(
              this.videoMaterialList[i],
              "fileId",
              this.$store.state.fileIdData.fileId
            );
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}

.photoMaterial-left {
  width: 220px;
  border: 1px solid #eee;
  padding: 20px 0px;
  flex-shrink: 0;
}

.photoMaterial-right {
  width: 100%;
}

.photoMaterial-left-title {
  padding: 0 20px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
}

.photoMaterial-left-input {
  padding: 0 20px;
  margin-bottom: 8px;
}

.iconPlus {
  float: right;
  font-size: 16px;
  font-weight: 600;
}

.photoMaterial-left-file {
  padding: 8px 20px;
  cursor: pointer;
}

.photoMaterial-left-file:hover {
  background: rgba(238, 245, 255, 1);
}

.photoMaterial-left-file_active {
  padding: 8px 20px;
  cursor: pointer;
  background: rgba(238, 245, 255, 1);
}

.photoMaterial-button {
  cursor: pointer;
  color: #4d94ff;
  padding: 2px 8px;
  border: 1px solid #4d94ff;
  margin-left: 10px;
  line-height: 22px;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px;
  display: block;
}

.material_operation {
  float: right;
  color: #409eff;
  margin-right: 20px;
}
</style>
<style lang="less" rel="stylesheet/less">
.videoMaterial {
  .el-upload-list {
    display: none !important;
  }

  .el-tree-node__content {
    height: 35px;
  }

  .avatar-uploader {
    display: flex;
    flex-wrap: wrap;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 80px;
    height: 80px;
    line-height: 80px;
  }

  .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
  }

  .el-upload-list--picture-card {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/materialCenter/videoMaterial.vue